import { getTimezoneMetadata } from "@blueprintjs/timezone";
import React, { useContext, useEffect, useState } from "react";
import { TimeZoneContext } from "utils/context";

export default function TimeZonePickerTarget() {
    const [abbr, setAbbr] = useState<string | undefined>();
    const [timeZone] = useContext(TimeZoneContext);

    useEffect(() => {
        const { abbreviation } = getTimezoneMetadata(timeZone);
        setAbbr(abbreviation);
    }, [timeZone]);

    return (
        <div className="timezone-selector">
            <div className="timezone-text">{abbr ? abbr : timeZone}</div>
        </div>
    );
}
